module.exports = __webpack_public_path__ + "static/media/videoCamera.46fe412c.svg";